import { css, styled } from "styled-components";

export const Preview1Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
`;

export const Preview1Background = styled.img`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
`;

export const Preview1HeaderAll = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  position: relative;
  border-radius: 4px;

  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview1Header = styled.div`
  position: relative;
  z-index: 2;
  width: calc(100% - 33px);
  padding: 16.5px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  > img {
    width: 79 0.965px;
    height: 26.29px;
    object-fit: cover;
  }
`;

export const Preview1HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5.47px;
  z-index: 2;
`;

export const Preview1HeaderStartDate = styled.div<{ color: string }>`
  height: 20px;
  color: ${({ color }) => color};
  font-family: Pretendard;
  font-size: 16.431px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const Preview1HeaderPubName = styled.div<{
  color: string;
  isShow: boolean;
}>`
  ${({ isShow }) =>
    !isShow &&
    css`
      height: 29.5px;
    `}
  color: ${({ color }) => color};
  font-family: Pretendard;
  font-size: 16.431px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  width: fit-content;

  ${({ isShow }) =>
    isShow &&
    css`
      padding: 4.79px 8.76px;
      border-radius: 4.382px;
      background: #6436e7;
    `}
`;

export const Preview1HeaderBottom = styled.div`
  position: relative;
  margin-top: 12.7px;
  width: calc(100% - 33px);
  padding: 0 16.5px;
  display: flex;
  flex-direction: column;
  z-index: 2;
`;

export const Preview1HeaderSubTitle = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  height: 20px;
  font-family: Pretendard;
  font-size: 16.431px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview1HeaderTitle = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  height: 33px;
  font-family: Pretendard;
  font-size: 27.385px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview1ContentWrapper = styled.div`
  margin-top: 10.82px;
  position: relative;
  width: calc(100% - 33px);
  flex: 1;
  padding: 0px 16.5px;
  display: flex;
  flex-direction: row;
  gap: 16.5px;
`;

export const Preview1ContentLeft = styled.div`
  width: 224.5px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16.5px;
`;

export const Preview1InfoWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  position: relative;
  width: 100%;
  height: 164px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2.191px 2.191px 0 rgba(0, 0, 0, 0.25);
  align-items: center;
  justify-content: center;
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview1NoticeWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  width: 100%;
  height: 197px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8.2px;

  p {
    margin: 0;
    padding: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-block-start: 0;
    margin-block-end: 0;
  }

  border-radius: 4.382px;
  background: #f0f0f0;
  box-shadow: 0 2.191px 2.191px 0 rgba(0, 0, 0, 0.25);
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview1PrizePoolWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
  showAddress: boolean;
}>`
  width: 100%;
  height: ${({ showAddress }) => (showAddress ? `281.237px` : `301.237px`)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7.9px;
  border-radius: 4.382px;
  background: #f0f0f0;
  box-shadow: 0 2.191px 2.191px 0 rgba(0, 0, 0, 0.25);
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview1PrizePoolTitle = styled.div`
  width: 191px;
  color: #444;
  font-family: Pretendard;
  font-size: 16.431px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview1PrizePoolListWrapper = styled.div<{
  fontSize: number;
  showAddress: boolean;
}>`
  width: 184px;
  height: ${({ showAddress }) => (showAddress ? `207px` : `227px`)};
  display: flex;
  flex-direction: column;
  gap: 2.74px;
  border-radius: 4.382px;
  background: #fff;
  padding: 11px 6.5px;
  font-size: ${({ fontSize }) => fontSize}px;
`;

export const Preview1PrizePoolItem = styled.div`
  width: calc(100% - 13px);
  max-height: 20px;
  padding: 0 6.5px;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 4.382px;
  background: #f0f0f0;

  color: #000;
  font-family: Pretendard;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview1NoticeTitle = styled.div`
  width: 191px;
  color: #444;
  font-family: Pretendard;
  font-size: 16.431px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview1NoticeValue = styled.div`
  width: 178px;
  height: 123px;
  padding: 10.9px 6.5px;
  color: #000;
  font-family: Pretendard;
  font-size: 8.763px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 4.382px;
  background: #fff;
  white-space: pre-line;
`;

export const Preview1InfoHeader = styled.div`
  width: calc(100% - 32.8px);
  height: 19.7px;
  padding: 8.2px 16.4px;
  color: #000;
  font-family: "Termina Test";
  font-size: 16.431px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview1InfoLine = styled.div`
  width: 213.604px;
  height: 0.548px;
  background: #dedede;
  margin-bottom: 5.48px;
`;

export const Preview1InfoItemWrapper = styled.div<{ fontSize: number }>`
  width: 100%;
  height: 116px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8px;
  font-size: ${({ fontSize }) => fontSize}px;
`;

export const Preview1InfoItem = styled.div<{ isShow: boolean }>`
  display: ${({ isShow }) => (isShow ? "flex" : "none")};
  width: 191.6px;
  height: 10.5px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  color: #000;
  font-family: Pretendard;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const PreviewImageWrapper = styled.div<{
  topPadding: number;
  rightPadding: number;
}>`
  position: absolute;
  top: ${({ topPadding }) => topPadding}px;
  right: ${({ rightPadding }) => rightPadding}px;
  height: ${({ topPadding }) =>
    topPadding ? `${165 - topPadding}px` : `165px`};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  z-index: 1;
  > img {
    height: 100%;
    object-fit: cover;
  }
`;

export const Preview1ContentRight = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
  showAddress: boolean;
}>`
  position: relative;
  width: 346.14px;
  height: ${({ showAddress }) => (showAddress ? "675.23px" : "695.23px")};
  display: flex;
  flex-direction: column;
  border-radius: 4.382px;
  background: #f0f0f0;
  box-shadow: 0 2.191px 2.191px 0 rgba(0, 0, 0, 0.25);
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview1StructureTitle = styled.div`
  padding: 8.216px 16.431px;
  color: #444;
  font-family: Pretendard;
  font-size: 16.431px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview1StructureListWrapper = styled.div<{
  showAddress: boolean;
}>`
  margin-left: 10.95px;
  width: calc(324.24px - 13px);
  height: ${({ showAddress }) =>
    showAddress ? `calc(648.481px - 41.8px)` : `calc(648.481px - 21.8px)`};
  padding: 10.9px 6.5px;
  display: flex;
  flex-direction: column;
  border-radius: 4.382px;
  background: #fff;
  gap: 2.74px;
`;

export const Preview1StructureHeader = styled.div`
  width: calc(100% - 32.86px);
  padding: 5.48px 16.43px;
  border-radius: 4.382px;
  background: #6436e7;
  display: flex;
  flex-direction: row;
  gap: 3.83px;
  align-items: center;
`;

export const Preview1StructureHeaderItem = styled.div<{ flex: number }>`
  flex: ${({ flex }) => flex};

  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 7.668px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const Preview1StructureRow = styled.div`
  width: calc(100% - 32.86px);
  flex: 1;
  padding: 0px 16.43px;
  display: flex;
  flex-direction: row;
  gap: 3.83px;
  align-items: center;
`;

export const Preview1StructureItem = styled.div<{
  flex: number;
  isShow: boolean;
}>`
  ${({ isShow }) => (isShow ? "" : "display: none;")}
  flex: ${({ flex }) => flex};

  color: #000;
  text-align: center;
  font-family: Pretendard;
  font-size: 7.668px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Preview1StructureBreak = styled.div`
  width: 100%;
  padding: 4.3px 0px;
  background: #d9d9d9;
  color: #121212;
  text-align: center;
  font-family: Pretendard;
  font-size: 7.668px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview1AddressWrapper = styled.div`
  margin-top: 10.9px;
  width: 100%;
  min-height: 10.9px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: rgb(49, 49, 49);
  text-align: center;
  font-family: Pretendard;
  font-size: 10.954px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
